import pluralize from "pluralize";
import {useState} from "react";
import {FiTrash} from "react-icons/fi";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {bulkDeleteSystemMetrics} from "@/pages/statuspages/utils/quickActions.ts";

interface StatusPageSystemMetricsBulkDeleteActionProps {
  selectedItems: Record<string, boolean>;
  statusPageId: number;
  setSelectedItems: (selectedItems: Record<string, boolean>) => void;
}

export const StatusPageSystemMetricsBulkDeleteAction = ({
  selectedItems,
  setSelectedItems,
  statusPageId,
}: StatusPageSystemMetricsBulkDeleteActionProps) => {
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const metricIds = Object.keys(selectedItems);

  return (
    <>
      <TableCrownButton onClick={() => setShowDelete(true)}>
        <Icon icon={FiTrash} />
        Delete
      </TableCrownButton>
      <DeleteActionDialog
        show={showDelete}
        title="Delete System Metrics"
        onConfirm={async () => {
          await bulkDeleteSystemMetrics(
            statusPageId,
            metricIds.map((str) => +str)
          );
          setSelectedItems({});
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete {metricIds.length} {pluralize("System Metric", metricIds.length)}?
      </DeleteActionDialog>
    </>
  );
};
